export const SET_ACTIVE_COUNTRY_OPTION = 'SET_ACTIVE_COUNTRY_OPTION';
export const SET_ACTIVE_LANGUAGE_OPTION = 'SET_ACTIVE_LANGUAGE_OPTION';
